
<template>
  <div class="fragment">
<!--        :hasCreateLabel="hasCreateLabel"-->
    <ExpressOrderCreationUser
        v-if="!advancedUser"
        :ex="ex"
        :selectedCountry="ex.express.delivery.delivery.country"
        @addProduct="addProduct"
        @removeProduct="removeProduct"
        @createExpress="createExpress"
        @createLabel="createLabel"
        @changeHasCreateLabel="changeHasCreateLabel"
    />

    <ExpressOrderCreationAdvancedUser
        v-else
        :ex="ex"
        :selectedCountry="ex.express.delivery.delivery.country"
        @addProduct="addProduct"
        @removeProduct="removeProduct"
        @createExpress="createExpress"
        @createLabel="createLabel"
    />


    <AuthorizePaymentPopup
            v-if="authorizePaymentPopup"
            :countMoney="authorizePaySum"
            :authorizePayData="authorizePayData"
            :authorizeError="authorizeError"
            :serverError="serverError"
            :changeCloseToSaveBtn="true"
            @close="()=>{$router.push($store.getters.GET_PATHS.expressOrders)}"
            @submitForm="submitAuthorizeInvoicePay"
    />

    <BraintreePaymentPopup
        v-if="braintreePaymentPopup"
        :amount="authorizePaySum"
        :payData="authorizePayData"
        :invoicePayId="authorizeInvoiceId"
        :changeCloseToSaveBtn="true"
        @submitForm="afterPay"
        @close="()=>{$router.push($store.getters.GET_PATHS.expressOrders)}"
    />

    <ThankYouPopup
            v-if="thankYouPopupPopup"
            @close="() => {$router.push($store.getters.GET_PATHS.expressOrders)}"
            :title="'common_paySuccessTitle'"
            :text="'common_paySuccessText'"
            :linkLastText="'common_paySuccessTextLink'"
            :linkLastTextHref="$store.getters.GET_PATHS.financeMyPayments + '?type=authorize'"
    />
  </div>
</template>

<script>
  import ExpressOrderCreationUser from "./ExpressOrderCreationUser/ExpressOrderCreationUser.vue";
  import ExpressOrderCreationAdvancedUser from "./ExpressOrderCreationAdvancedUser/ExpressOrderCreationAdvancedUser";
  import {Express} from "../../models/Express";
  import {proformMixins} from "../../../../../mixins/proformMixins/proformMixins";
  import {expressMixinsFromCard} from "../../../../../mixins/expressMixins/expressMixin";
  import {DHL_DELIVERY_SERVICE, EXPRESS_FROM_TRANSACTIONS} from "../../../../../staticData/staticVariables";
  import AuthorizePaymentPopup from "../../../../coreComponents/Popups/AuthorizePaymentPopup/AuthorizePaymentPopup";
  import ThankYouPopup from "../../../../coreComponents/Popups/ThankYouPopup/ThankYouPopup";
  import {paymentBlockFunc} from "../../../../../mixins/dashboardMixins/paymentBlockFunc";
  import BraintreePaymentPopup from "@/components/coreComponents/Popups/BraintreePaymentPopup/BraintreePaymentPopup";

  export default {
    name: "ExpressOrderCreation",
    components: {
      BraintreePaymentPopup,
      ThankYouPopup,
      AuthorizePaymentPopup,
      ExpressOrderCreationUser,
      ExpressOrderCreationAdvancedUser,
    },

    mixins: [
      proformMixins,
      expressMixinsFromCard,
      paymentBlockFunc,
    ],

    watch: {
      loadUserRoleAndAuthorizedData: function() {
        this.ex.setSenderInfo(this.loadUserAuthorizedData.user)

        if(this.isCurrentUserRoleUser){
          this.ex.setExpressUser(this.loadUserAuthorizedData.user)
        }
      },

      downloadPermissions() {
        this.checkPermission()
      },
    },

    data() {
      return {
        ex: new Express(),

        // hasCreateLabel: false,

        serverError: false,
        authorizePayData: {},
        authorizePaySum: -1,
        authorizeInvoiceId: -1,
        authorizePaymentPopup: false,
        braintreePaymentPopup: false,
        thankYouPopupPopup: false,
        authorizeError: false,

        createdExpressID: -1,

        advancedUser: false
      }
    },

    created() {

      if(this.downloadPermissions){
        if(!this.checkPermission()) return
      }

      this.ex.setType(this.$route.params.type)
      if (this.ex.express.type === DHL_DELIVERY_SERVICE.id) {
        this.$store.dispatch('getExpressCreate').then(response => {
          let respData = this.getRespData(response)
          if (respData.order_express_country_types && respData.order_express_country_types[DHL_DELIVERY_SERVICE.id] &&
              respData.order_express_country_types[DHL_DELIVERY_SERVICE.id].length > 0) {
            this.ex.express.orderCountryTypesArray = respData.order_express_country_types[DHL_DELIVERY_SERVICE.id]
            this.ex.express.orderCountryType = this.ex.express.orderCountryTypesArray[0].value
          }
        })
      }
      //default phone number for express create
      this.ex.express.personal.setPersonalPhone('+1-612-203-1280')

      this.advancedUser = this.isExpertUser

      if(this.$route.params.typeTransaction && this.$route.params.id){
        let type = this._.find(EXPRESS_FROM_TRANSACTIONS, {name: this.$route.params.typeTransaction})


        this.ex.setExpressTypeTransaction({
          type: type.value,
          id: this.$route.params.id,
        })

        this.$store.dispatch('getIdentifyExpressOrderFromTrn', {data: {
            "from_model" : this.ex.express.typeTransaction,
            "model_id": this.ex.express.typeTransactionId
          }}).then(response => {
          this.ex.setOrderPrice(
              this.ex.express.type === DHL_DELIVERY_SERVICE.id && this.getRespData(response).paymentTransaction?.warehouse_amount ?
              (+response.data.data.paymentTransaction.warehouse_amount * 0.8).toFixed(2) : this.getRespData(response).orderPrice ? response.data.data.orderPrice : ''
          )

          if (this.ex.express.type === DHL_DELIVERY_SERVICE.id && this.getRespData(response).paymentTransaction?.warehouse_amount) {
            this.ex.setFreightCost(
                (+response.data.data.paymentTransaction.warehouse_amount - (+response.data.data.paymentTransaction.warehouse_amount * 0.8).toFixed(2)).toFixed(2)
            )
          }

          if (this.ex.express.type === DHL_DELIVERY_SERVICE.id && this.getRespData(response).paymentTransaction?.warehouse_amount && this.ex.express.products.length > 0) {
            this.ex.express.products[0].setProductPrice(this.ex.getOrderPrice())
          }

          if(this.getRespData(response).paymentTransaction){
            this.ex.setExternalTrnInfo(this.getRespData(response).paymentTransaction)
            this.ex.express.paymentTransactionId = this.getRespData(response)?.paymentTransaction?.id || -1
            console.log(this.ex.express.typeTransaction, this.ex.express.paymentTransactionId);
          } else {
            this.$store.dispatch('getImportOrders', this.ex.express.typeTransactionId).then(response => {
              console.log(this.getRespData(response));
              this.ex.setImportOrderInfo(this.getRespData(response))
              // skip transaction if import order not have payment_transaction_id
              if(!this.getRespData(response)?.payment_transaction_id) {
                this.ex.express.typeTransactionId = ''
                this.ex.express.sendType = this.ex.express.sendTypes.warehouse
              }
            }).catch(error => this.createErrorLog(error))

          }

          this.ex.setExternalTrnInfo(
            this.getRespData(response).paymentTransaction !== null ? this.getRespData(response).paymentTransaction : false
          )
        }).catch(error => this.createErrorLog(error))
      }

      if(this.loadUserAuthorizedData){
        this.ex.setSenderInfo(this.loadUserAuthorizedData.user)

        if(this.isCurrentUserRoleUser){
          this.ex.setExpressUser(this.loadUserAuthorizedData.user)
        }
      }

      this.initializeProductProformArray(this.ex.express.products)
    },

    methods: {

      afterPay() {

        this.$store.dispatch('afterInvoicePayStatusUpdate', this.createdExpressID)
        this.braintreePaymentPopup = false

        this.changeThankYouPopupPopup(true)
      },

      submitAuthorizeInvoicePay(data){
        this.payAuthorizeInvoice({data: data, invoiceId: this.authorizeInvoiceId}).then(status => {
          if(status){
            this.$store.dispatch('afterInvoicePayStatusUpdate', this.createdExpressID)
          }
          this.authorizePaymentPopup = false

          setTimeout(() => {
            this.changeThankYouPopupPopup(true)
          }, 200)
        })
      },

      addProduct(){
        let newIndex = this.ex.addProduct()
        this.initializeProductProformArray(this.ex.express.products, newIndex)
      },

      removeProduct(index) {
        this.ex.removeProduct(index)
      },

      createLabel() {
        this.createExpress({draft: true, createLabel: true})
      },

      createExpress({draft, createLabel = false}) {
        if(this.$store.getters.getIsAdminRights === 'admin') {
          if(!this.checkAdminValidation()) return
        }

        let data = this.ex.prepareCreation(
          draft,
          this.$store.getters.getUserProfile.id
        )

        this.$store.dispatch('createExpress', data).then(response => {
          if (this._.has(response, 'data') &&
            response.data.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {
            let expressId = response.data.data.id
            this.createdExpressID = expressId
            let expressType = this.getExpressTypeById(this.ex.express.type)

            if (createLabel && (this.ex.express.files.length > 0 || this.ex.express.vatNumberFile.getFiles().length > 0)) {
              this.createFiles(expressId).then(() => {
                this.makeLabelHandler(expressId, expressType).then((status) => {
                  if(!this._.has(status, 'statusPaid')){
                    this.$router.push(this.$store.getters.GET_PATHS.expressOrders + this.$store.getters.getExpressFilter)
                  }
                }).catch(error => this.createErrorLog(error))
              }).catch(error => this.createErrorLog(error))
              return
            }

            if (createLabel) {
              this.makeLabelHandler(expressId, expressType).then((status) => {
                if(!this._.has(status, 'statusPaid')){
                  this.$router.push(this.$store.getters.GET_PATHS.expressOrders + this.$store.getters.getExpressFilter)
                }
              }).catch(error => this.createErrorLog(error))
              return
            }

            if(this.ex.express.files.length > 0 || this.ex.express.vatNumberFile.getFiles().length > 0) {
              this.createFiles(expressId).then(() => {
                this.$router.push(this.$store.getters.GET_PATHS.expressOrders + this.$store.getters.getExpressFilter)
              }).catch(error => this.createErrorLog(error))
              return
            }

            this.$router.push(this.$store.getters.GET_PATHS.expressOrders + this.$store.getters.getExpressFilter)

            this.openNotify('success', 'common_notificationRecordCreated')

          } else if (response.response.status === this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE) {
            let errors = response.response.data.errors
            this.notifyErrorHelper(errors)
          } else {
            this.openNotify('error', 'common_notificationUndefinedError')
          }
        }).catch(error => this.createErrorLog(error))
      },

    },

  }
</script>

<style scoped>

</style>
